var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_578_5080",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.199951,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_578_5080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12L10.8672 13.2615C10.7737 13.332 10.6817 13.3345 10.5912 13.2692C10.5009 13.2039 10.4724 13.1192 10.5058 13.0152L11.127 10.973L9.473 9.7077C9.38967 9.6372 9.36633 9.55095 9.403 9.44895C9.4395 9.34712 9.50967 9.2962 9.6135 9.2962H11.6578L12.2787 7.2847C12.3121 7.1807 12.3858 7.1287 12.5 7.1287C12.6142 7.1287 12.6879 7.1807 12.7213 7.2847L13.3422 9.2962H15.3712C15.4751 9.2962 15.5478 9.34712 15.5895 9.44895C15.6312 9.55095 15.6103 9.6372 15.527 9.7077L13.8577 10.973L14.4788 13.0152C14.5121 13.1192 14.4836 13.2039 14.3932 13.2692C14.3029 13.3345 14.2109 13.332 14.1173 13.2615L12.5 12ZM12.5 20.6807L8.18075 22.048C7.88592 22.1518 7.61542 22.1117 7.36925 21.9277C7.12308 21.7437 7 21.5011 7 21.2V15.273C6.36667 14.6115 5.875 13.8467 5.525 12.9787C5.175 12.1109 5 11.1846 5 10.2C5 8.10762 5.72692 6.33453 7.18075 4.8807C8.63458 3.42687 10.4077 2.69995 12.5 2.69995C14.5923 2.69995 16.3654 3.42687 17.8193 4.8807C19.2731 6.33453 20 8.10762 20 10.2C20 11.1846 19.825 12.1109 19.475 12.9787C19.125 13.8467 18.6333 14.6115 18 15.273V21.2C18 21.5011 17.8769 21.7437 17.6307 21.9277C17.3846 22.1117 17.1141 22.1518 16.8193 22.048L12.5 20.6807ZM12.5 16.2C14.1667 16.2 15.5833 15.6166 16.75 14.45C17.9167 13.2833 18.5 11.8666 18.5 10.2C18.5 8.53328 17.9167 7.11662 16.75 5.94995C15.5833 4.78328 14.1667 4.19995 12.5 4.19995C10.8333 4.19995 9.41667 4.78328 8.25 5.94995C7.08333 7.11662 6.5 8.53328 6.5 10.2C6.5 11.8666 7.08333 13.2833 8.25 14.45C9.41667 15.6166 10.8333 16.2 12.5 16.2ZM8.5 20.2345L12.5 19.1615L16.5 20.2345V16.5192C15.9295 16.891 15.3052 17.1808 14.627 17.3885C13.9487 17.5961 13.2397 17.7 12.5 17.7C11.7603 17.7 11.0513 17.5961 10.373 17.3885C9.69483 17.1808 9.0705 16.891 8.5 16.5192V20.2345Z",
    fill: "#FAFAFA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremium);
export default __webpack_public_path__ + "static/media/iconPremium.193ccdacb2cb8b8a92b6c820c202d3a9.svg";
export { ForwardRef as ReactComponent };